import { API } from "aws-amplify";

export async function fetchMonitorById(monitorId: number) {
  const body: any = {
    email: localStorage.getItem("username"),
    tableName: "response-times"
  }

  try {
    const res: any = await API.post("data", "/data/id/" + monitorId, {
      body,
    });
    return res;
  } catch(e) {
    console.log(e)
  }
}


// WEBPACK FOOTER //
// ./src/utils/api/fetchMonitorById.ts